import { render } from "./SchedulesMain.vue?vue&type=template&id=5941a84c&scoped=true"
import script from "./SchedulesMain.vue?vue&type=script&lang=js"
export * from "./SchedulesMain.vue?vue&type=script&lang=js"

import "./../../assets/styles/schedules/main.scss?vue&type=style&index=0&id=5941a84c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5941a84c"]])

export default __exports__